export default __webpack_public_path__ + "static/media/Abidur-cv.97d34f0a.pdf";